import dayjs from 'dayjs';
import { TFunction } from 'i18next';
import { ToastOptions } from 'modules/toast/hooks/useToast';
import { Trans } from 'react-i18next';
import { ExtractionErrorOnboardingRedirectButton } from 'shared/components/ExtractionErrorOnboardingRedirectButton';

export const extractionInProgressToastId = 'extractionInProgressToast';
export const extractionInProgress = (t: TFunction): ToastOptions => ({
  toastId: extractionInProgressToastId,
  closeable: false,
  loading: true,
  title: t('toast:extraction.inProgress.title'),
  message: t('toast:extraction.inProgress.message'),
});

export const extractionSuccessToastId = 'extractionSuccessToast';
export const extractionSuccess = (t: TFunction): ToastOptions => ({
  toastId: extractionSuccessToastId,
  icon: 'check',
  autoClose: 120000,
  title: t('toast:extraction.success.title'),
  message: t('toast:extraction.success.message'),
});

export const extractionErrorToastId = 'extractionErrorToast';
export const extractionError = (t: TFunction): ToastOptions => ({
  toastId: extractionErrorToastId,
  color: 'warning',
  title: t('toast:extraction.error.title'),
  icon: 'info',
  autoClose: 120000,
  message: (
    <Trans
      i18nKey="toast:extraction.error.message"
      components={{
        link: <ExtractionErrorOnboardingRedirectButton />,
      }}
    />
  ),
});

export const profileVerifiedToastId = 'profileVerifiedToastId';
export const profileVerified = (t: TFunction): ToastOptions => ({
  toastId: profileVerifiedToastId,
  color: 'success',
  title: t('toast:profile.verified.title'),
  icon: 'check',
  autoClose: 120000,
  message: <>{t('toast:profile.verified.message')}</>,
});

export const cvReuploadFileTooLargeToastId = 'cvReuploadFileTooLargeToastId';
export const cvReuploadFileTooLarge = (t: TFunction): ToastOptions => ({
  toastId: cvReuploadFileTooLargeToastId,
  color: 'error',
  title: t('toast:cvReupload.fileTooLarge.title'),
  icon: 'cross',
  autoClose: 10000,
  message: <>{t('toast:cvReupload.fileTooLarge.message')}</>,
});

export const cvReuploadFileInvalidTypeId = 'cvReuploadFileInvalidTypeToastId';
export const cvReuploadFileInvalidType = (t: TFunction): ToastOptions => ({
  toastId: cvReuploadFileInvalidTypeId,
  color: 'error',
  title: t('toast:cvReupload.fileInvalidType.title'),
  icon: 'cross',
  autoClose: 10000,
  message: <>{t('toast:cvReupload.fileInvalidType.message')}</>,
});

export const cvReuploadExtractionFailedToastId = 'cvReuploadExtractionFailedToastId';
export const cvReuploadExtractionFailed = (t: TFunction, extractionDate: Date): ToastOptions => ({
  toastId: cvReuploadExtractionFailedToastId,
  color: 'warning',
  title: t('toast:cvReupload.extractionFailed.title'),
  icon: 'info',
  autoClose: 120000,
  message: (
    <Trans
      i18nKey="toast:cvReupload.extractionFailed.message"
      values={{
        date: dayjs(extractionDate).format('DD.MM.YYYY'),
      }}
      components={{
        link: <ExtractionErrorOnboardingRedirectButton label={t('common:here')} />,
      }}
    />
  ),
});

export const newNotificationToast = (title: string, message?: string): ToastOptions => ({
  icon: 'info',
  autoClose: 10000,
  title,
  message,
});

export const allToastIds = [
  extractionInProgressToastId,
  extractionSuccessToastId,
  extractionErrorToastId,
  profileVerifiedToastId,
  cvReuploadFileTooLargeToastId,
  cvReuploadFileInvalidTypeId,
  cvReuploadExtractionFailedToastId,
];
